const initialState = {
  digitalPayments: [],
  totalPages: 0,
  loadingDigitalPayments: false
}

const digitalPaymentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'START_DIGITAL_PAYMENTS_REQUEST':
      return {
        ...state,
        loadingDigitalPayments: true
      };
    case 'END_DIGITAL_PAYMENTS_REQUEST':
      return {
        ...state,
        loadingDigitalPayments: false
      };
    case 'SET_DIGITAL_PAYMENTS':
      return {
        ...state,
        digitalPayments: action.data.payment_transactions,
        totalPages: action.data.total_pages
      };
    default:
      return state;
  }
};

export default digitalPaymentsReducer;